import { render, staticRenderFns } from "./DetailedProducts.vue?vue&type=template&id=395c7810&scoped=true&"
import script from "./DetailedProducts.vue?vue&type=script&lang=js&"
export * from "./DetailedProducts.vue?vue&type=script&lang=js&"
import style0 from "./DetailedProducts.vue?vue&type=style&index=0&id=395c7810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395c7810",
  null
  
)

export default component.exports